import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}

interface IAddProforma {
  numero: number | undefined;
  fuente: string | null;
}

interface IResponse {
  anulada: string | boolean | number | null;
  sustituida: string | boolean | number | null;
  numero: number | null;
}

export const getObtainProform = async (
  query: IAddProforma
): Promise<IResponse> => {
  try {
    const res = await apiClient.post<ApiResponse<IResponse>>(
      Endpoints.ObtenerProforma,
      {
        numero: query.numero,
        fuente: query.fuente,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
